import React from 'react'

const ColorBar = (props) => (
    <div style={{height:25, margin:5 }} className='d-flex justify-content-center align-items-center'>
        <div style={{ height: props.height != null ? props.height : '5px', width: props.width != null ? props.width : '50px', backgroundColor: props.color }}></div>
    </div>
)

export default ColorBar;


// WEBPACK FOOTER //
// ./src/Components/Rutas/ColorBar.js